
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
countries.registerLocale(enLocale);
import { App } from 'vue'



export default {
    install(app: App) {
        app.provide('getName', (countryCode, langCode, type) => {
            return countries.getName(countryCode, langCode, type);
        });
    },
};